// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-container[data-v-bd59408a]{padding-bottom:10px}.existing-users-header[data-v-bd59408a]{display:flex;justify-content:space-between}", ""]);
// Exports
module.exports = exports;
